<template>
  <div v-if="field" class="radio-input">
    <label class="subtitle-2 black--text pl-3">
      {{field.label}}
      <span v-if="this.field.required==1" class="orange--text text--darken-3">*</span>
    </label>
    <div class="list mt-1 pt-1">
      <div class="input-group">
        <input
          :id="'radio-yes-'+field.id"
          v-model="model"
          value="yes"
          type="radio"
          @change="update()"
        />
        <label :for="'radio-yes-'+field.id">Yes</label>
      </div>
      <div class="input-group">
        <input
          :id="'radio-no-'+field.id"
          v-model="model"
          value="no"
          type="radio"
          @change="update()"
        />
        <label :for="'radio-no-'+field.id">No</label>
      </div>
    </div>
    <div class="errorMsg" v-if="block.errorMessages">{{block.errorMessages[0]}}</div>
    <div class="hint" v-if="field.hint">{{field.hint}}</div>
  </div>
</template>
<script>
import FieldMixin from "./FieldMixin";
export default {
  mixins: [FieldMixin],
  name: "FieldYesNo",
  methods: {
    validate: function() {
      /*if (this.model.data) {
        for (let index = 0; index < this.field.options.length; index++) {
          const opt = this.field.options[index];
          if (opt.value === this.model.data) {
            this.model.upcharge = opt.upcharge;
          }
        }
      }*/

      if (this.field.required === 1 && !this.model) {
        this.isValid = false;
        this.addError(this.block.id,"Champ obligatoire");

      } else {
        this.isValid = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.radio-input {
  .list {
    display: flex;
    input {
      display: none;
      &:checked ~ label {
        background-color: #e76c2f;
        color: #fff;
      }
    }
    label {
      margin-right: 1rem;
      font-size: 0.8rem;
      padding: 0.5rem 1.2rem;
      background-color: #e8e8e8;
      transition: 0.5s;
      border-radius: 10px;
    }
  }
}
</style>
